const shouldEnableTestIds = (): boolean =>
  process.env.NODE_ENV === 'test' ||
  /\bwithRoles\b/.test(globalThis.location?.search ?? '');

export const useTID = (name: string, testid: string) =>
  shouldEnableTestIds() ? { 'data-testid': `:${name}-${testid}` } : {};

export const useTestId = (id: string) =>
  shouldEnableTestIds() ? { 'data-testid': id } : {};
